export const CI_TYPES_META = {
  WORKSTATION: { label: 'Arbeitsplatz',   icon: 'mdi-monitor' },
  ENGINE:      { label: 'Fahrzeug',       icon: 'mdi-fire-truck' },
  RADIO:       { label: 'Funkgerät',      icon: 'mdi-radio-handheld' },
  DME:         { label: 'Meldeempfänger', icon: 'mdi-bell-ring-outline' },
  SERVER:      { label: 'Server',         icon: 'mdi-server' },
  SIRENE:      { label: 'Sirene',         icon: 'mdi-bullhorn-outline' },
  STATION:     { label: 'Wache',          icon: 'mdi-fire-station' },
  ROOT:        { label: 'System',         icon: 'mdi-file-tree' },
}

export const getCITypeMeta = (type) => (type && CI_TYPES_META[type]) || null

export const CREATABLE_CI_TYPES = ['WORKSTATION', 'ENGINE', 'RADIO', 'DME', 'SERVER', 'SIRENE']
  .map(t => ({ type: t, name: CI_TYPES_META[t].label, icon: CI_TYPES_META[t].icon }))

export const CI_STATUSES_META = {
  OK:           { label: 'OK',          icon: 'mdi-check-circle',     color: 'green' },
  WARNING:      { label: 'Warnung',     icon: 'mdi-alert-circle',     color: 'orange' },
  OUTAGE:       { label: 'Störung',     icon: 'mdi-close-circle',     color: 'red' },
  POWER_OUTAGE: { label: 'Stromausfall', icon: 'mdi-power-plug-off',  color: 'grey darken-3' },
}

export const getCIStatusMeta = (status) => {
  if (status && CI_STATUSES_META[status]) return CI_STATUSES_META[status]
  return { label: status || 'Unbekannt', icon: 'mdi-help-circle', color: 'blue-grey' }
}
